{
  "title": "如何婉拒評審邀請或退出本競賽評審",
  "description": "無法擔任評審時，在邀請階段婉拒，或在已有指派後退出，讓主辦方及早重新安排。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，主辦方會知道您無法擔任，並能再次邀請或重新指派，您也不會再被催審。",
  "roleNote": "評審",
  "prerequisites": ["已收到評審邀請，或已是該競賽的評審"],
  "pathLabel": "總覽 → 待回覆的評審邀請；評審任務 → 無法擔任評審？退出本競賽評審",
  "steps": [
    {
      "title": "1. 還沒接受邀請：婉拒",
      "description": "已有平台帳號者，登入後在「總覽」頁的「待回覆的評審邀請」按「婉拒」，可填寫原因（選填）後按「確認婉拒」。婉拒不會授予任何角色；主辦方會在邀請列表看到「已婉拒」與原因，並可再次邀請。邀請的回覆期限為 7 天。"
    },
    {
      "title": "2. 新帳號（臨時密碼）的情況",
      "description": "以臨時密碼建立的新帳號，在完成首次改密碼時會自動成為評審，無法事前婉拒。若無法擔任，請在評審任務頁按「無法擔任評審？退出本競賽評審」並勾選「同時放棄這場競賽的評審身分」（沒有任何指派也可以使用），或直接聯絡主辦方。"
    },
    {
      "title": "3. 已有指派：退出本競賽評審",
      "description": "在評審任務頁的清單下方點「無法擔任評審？退出本競賽評審」，必須填寫原因並確認。系統會取消您在該競賽所有尚未送出評分的指派；已送出的評分、您的評審角色與草稿紀錄都不會被刪除。若同時勾選「同時放棄這場競賽的評審身分」，您的評審角色也會被移除，這場競賽不再出現在您的評審任務；主辦方需重新邀請才能再擔任。"
    },
    {
      "title": "4. 後續",
      "description": "主辦方會在稽核紀錄看到您的原因，並在「審查進度」看到您的指派件數下降，之後重新指派給其他評審。您無法自行恢復，如需恢復請聯絡主辦方。"
    }
  ],
  "afterward": [
    "婉拒的邀請在主辦方的邀請列表顯示「已婉拒」與原因",
    "退出後，您尚未送出的指派都會被取消，已送出的評分不受影響",
    "退出與婉拒都會留下稽核紀錄"
  ],
  "nextSteps": "若只是想確認有哪些作品，請見「如何查看指派給我的作品」。",
  "faq": [
    {
      "q": "婉拒之後還能反悔嗎？",
      "a": "不能自行反悔。請聯絡主辦方，他們可以再次邀請您。"
    },
    {
      "q": "退出後我已經送出的分數會被刪除嗎？",
      "a": "不會。已送出的評分、評審角色與草稿紀錄都保留，只有尚未送出評分的指派會被取消。"
    },
    {
      "q": "我只有一兩件不方便評，需要退出整場嗎？",
      "a": "不需要。若是與參賽者有關係，請改用該作品旁的「申報利益衝突」；退出是取消您在該競賽所有尚未送出的指派。"
    }
  ]
}
